import { nodePasteRule } from '@tiptap/core';

import { RecipientSelector } from '../../components/recipient/recipient-selector';
import { matchers } from '../config/matchers';
import { Tag } from './tag';

export const matchQuery = matchers.mention.possible;

export const Mention = Tag.extend({
	name: 'mention',
	addOptions() {
		return {
			...this.parent?.(),
			char: '&',
			component: RecipientSelector,
			debounceFetch: true,
			insertPrefixSpace: true,
			matchQuery,
			requireSelection: true,
		};
	},

	addPasteRules() {
		return [
			nodePasteRule({
				find: matchers.mention.paste,
				type: this.type,
				getAttributes: (match) => {
					return {
						id: match[0].slice(1),
					};
				},
			}),
		];
	},
});
